import { Field as FieldType } from '../fieldtypes/Field';
import type { IFIXParser } from '../IFIXParser';
import type { Message } from '../message/Message';

/**
 * Handles the SequenceReset message in a FIX session.
 * This function processes the SequenceReset message and updates the message sequence number
 * to the new value specified in the message.
 *
 * @param {IFIXParser} parser - The FIX parser instance handling the session
 * @param {Message} message - The SequenceReset message containing the new sequence number
 */
export const handleSequenceReset = (parser: IFIXParser, message: Message): void => {
    const newSeqNo: number = message.getField(FieldType.NewSeqNo)?.value as number;
    if (newSeqNo && Number.isFinite(newSeqNo)) {
        parser.logger.log({
            level: 'info',
            message: `${
                parser.parserName
            } (${parser.protocol?.toUpperCase()}): -- SequenceReset: new sequence number ${newSeqNo}`,
            fix: message.encode('|'),
        });
        parser.messageStoreIn.setNextMsgSeqNum(Number(newSeqNo) - 1);
    }
};
